import {VatRate} from "./vatRate";
import {Category} from "./category";
import {ServiceResourceGroup} from "./serviceResourceGroup";
import {Operator} from "./operator";
import {File} from "./file";
import {Resource} from "./resource";

export class Service {
    id: string;
    operator?: Operator;
    category: Category;
    vatRate?: VatRate;
    requiredTime: number;
    requiredCredits: number;
    blockedTimeBeforeService: number;
    blockedTimeAfterService: number;
    breakTimeInService: number;
    popularity: number;
    priceGross: number;
    privateDescription: string;
    name: string;
    description: string;
    promotion: boolean;
    groupTraining: boolean;
    images?: File[];
    documents?: File[];
    resourceGroups?: ServiceResourceGroup[];
    onlineReservation: boolean;
    resources: Resource[];
    type: string;
}
